module.exports = import("https://unpkg.com/three@0.140.0/build/three.module.js");;